// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTot";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import { Table, Checkbox } from "semantic-ui-react";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let maxwidth="80vw";
const ListWorkingHoursShortageReport = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    disablePagination
  }) => {
    const [thead] = useState([
      "Date",
      "Project",
      "Employee",
      "Task",
      "Description",
      "Estimated Hours",
       "Hours Spent",
       "Hours Billable",
      //  "Leave Type",
       "Status",
       

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);


    return (
      <Fragment>
        <div className="fixed-header">
          <div>
         
            &nbsp;
          
            <div className="d-inline float-right ">
           
            </div>
          </div>
        </div>
        <div className="" style={{ maxWidth: maxwidth, overflowY: disablePagination ? "visible !important" : "auto", maxHeight: disablePagination ? "auto !important" : "80vh" }}>
        <Table bordered hover responsive>
        <thead className="bg-primary text-white">
          <tr>
            <th>#</th>
            <th>Employee ID</th>
            <th>Employee Name</th>
            <th>Department</th>
            <th>First In</th>
            <th>Last Out</th>
            <th>Total Duration</th>
            <th>Work Duration</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody> 
          {empTask.map((record, index) => (
            <tr key={record.id}>
              <td>{index + 1}</td>
              <td>{record.employeeID}</td>
              <td>{record.employeeName}</td>
              <td>{record.departmentName}</td>
              <td>{record.firstPunchIn}</td>
              <td>{record.lastPunchOut}</td>
              <td>{record.totalWorkHours}</td>
              <td>{record.workDuration }</td>
              <td>{record.remarks}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
     
      </Fragment>
    );
  }
);

export default ListWorkingHoursShortageReport;
